import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';  // Correct way to import the XLSX library
import Swal from 'sweetalert2';
import ReactPaginate from "react-paginate";
import './AdminPage.css'; // Assuming the CSS file is named AdminPage.css
import { FaEdit } from 'react-icons/fa';

const AdminPage = () => {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [isSignup, setIsSignup] = useState(false);
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // const [name, setName] = useState('');
  const [products, setProducts] = useState([]);
  const [uploadedData, setUploadedData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [soldCurrentPage, setSoldCurrentPage] = useState(1);
  const [soldTotalPages, setSoldTotalPages] = useState(1);
  const [soldItemsPerPage, setSoldItemsPerPage] = useState(20);
  const [selectedProducts, setSelectedProducts] = useState(new Set());
  const [data, setData] = useState([]);
  const [editRowIndex, setEditRowIndex] = useState(null); // Tracks the row being edited
  const [editValues, setEditValues] = useState({}); // Tracks edited values
  const [soldProducts, setSoldProducts] = useState([]);
  const [showProducts, setShowProducts] = useState(false);
  const [showSoldStock, setShowSoldStock] = useState(false);
  const [certificateSearchTerm, setCertificateSearchTerm] = useState("");
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);

  const getBackendUrl = () => {
    return window.location.hostname === 'localhost'
      ? process.env.REACT_APP_BACKEND_URL_LOCAL
      : process.env.REACT_APP_BACKEND_URL_PRODUCTION;
  };

  // const handleSignup = async () => {
  //   try {
  //     const response = await axios.post(`${getBackendUrl()}/api/admin/signup`, { name, email, password });
  //     Swal.fire("Registration Successful", response.data.message, "success");
  //     setIsSignup(false);
  //   } catch (error) {
  //     console.error(error);
  //     Swal.fire("Signup Failed", error.response?.data?.message || "Invalid credentials", "error");
  //   }
  // };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await axios.post(`${getBackendUrl()}/api/admin/login`, {
  //       email,
  //       password,
  //     });
  //     console.log('Login successful:', response.data);

  //     // Store the token and adminId in localStorage
  //     localStorage.setItem('token', response.data.token);
  //     localStorage.setItem('adminId', response.data.adminId); // Store the adminId as well
  //     Swal.fire("Login Successful", response.data.message, "success");
  //     setIsLoggedIn(true);
  //   } catch (error) {
  //     console.error('Login error:', error.response.data.message);
  //     Swal.fire("Login Failed", error.response?.data?.message || "Invalid credentials", "error");
  //   }
  // };

  const toggleSelection = (productId) => {
    setSelectedProducts((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(productId)) {
        newSelected.delete(productId);
      } else {
        newSelected.add(productId);
      }
      return newSelected;
    });
  };

  const fetchSoldProducts = useCallback(async (searchTerm = "") => {
    try {
      // Here we use a large limit to fetch all sold products (or you could implement pagination)
      const response = await axios.get(`${getBackendUrl()}/api/product/sold-products`, {
        params: {
          page: soldCurrentPage,
          limit: soldItemsPerPage,
          search: searchTerm, // Pass the search term to the API
        },
      });
      if (response.data.soldProducts.length === 0 && searchTerm) {
        setIsSearchEmpty(true); // No results found for the search term
      } else {
        setIsSearchEmpty(false); // Reset if results are found
      }
      setSoldProducts(response.data.soldProducts);
      setSoldTotalPages(response.data.totalPages);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch sold products", "error");
    }
  }, [soldCurrentPage, soldItemsPerPage]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" }); // Ensure empty values are not undefined

        const requiredFields = [
          "Shape", "Certificate No", "Carat", "Color", "Clarity",
          "Cut", "Polish", "Symmetry", "Fluorescence", "Length",
          "Breadth", "Height", "LAB", "Price/ct", "Amount"
        ];
        const optionalFields = ["BGM", "H&C", "3EX"];

        // Ensure each row has all required fields
        const formattedData = jsonData.map(row => {
          let formattedRow = {};
          [...requiredFields, ...optionalFields].forEach(field => {
            formattedRow[field] = row[field] !== undefined ? row[field] : ""; // Ensure missing fields are empty
          });
          return formattedRow;
        });

        // Validate data: All required fields must be filled
        const isValid = formattedData.every(row =>
          requiredFields.every(field => row[field] !== "")
        );

        if (!isValid) {
          Swal.fire({
            icon: "error",
            title: "Invalid File",
            text: "Some required fields are missing. Only BGM, H&C, and 3EX can be empty.",
          });
        } else {
          setUploadedData(formattedData);
        }
      };
      reader.readAsBinaryString(file);
    }
  };

  const fetchProducts = useCallback(async () => {
    try {
      const response = await axios.get(
        `${getBackendUrl()}/api/product/products-details`,
        {
          params: {
            page: currentPage,
            limit: itemsPerPage
          }
        }
      );
  
      if (response.data.products && response.data.products.length > 0) {
        setProducts(response.data.products);
        setTotalPages(response.data.totalPages);
      } else {
        setProducts([]);
        setTotalPages(1);
        setCurrentPage(1); // Reset to first page if no data
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      Swal.fire("Error", "Failed to fetch products", "error");
      setProducts([]);
      setTotalPages(1);
      setCurrentPage(1); // Reset to first page on error
    }
  }, [currentPage, itemsPerPage]);

  const deleteSelectedProducts = async () => {
    if (selectedProducts.size === 0) {
      Swal.fire('No products selected', 'Please select at least one product to delete.', 'warning');
      return;
    }

    const confirm = await Swal.fire({
      title: `Are you sure?`,
      text: `You are about to delete ${selectedProducts.size} products.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete them!',
      cancelButtonText: 'Cancel'
    });

    if (confirm.isConfirmed) {
      try {
        // const adminId = localStorage.getItem("adminId");
        const response = await fetch(`${getBackendUrl()}/api/product/delete-products`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productIds: Array.from(selectedProducts) })
        });

        const data = await response.json();
        if (response.ok) {
          Swal.fire('Deleted!', data.message, 'success');
          setSelectedProducts(new Set());
          fetchProducts();
          fetchSoldProducts();
        } else {
          Swal.fire('Error', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('Error', 'Something went wrong!', 'error');
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setUploadedData([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input field
    }
  };

  const handleRemoveFile2 = () => {
    setFile2(null);
    setData([]); // Clear the table data associated with file2
    if (fileInputRef2.current) {
      fileInputRef2.current.value = ""; // Clear only the second file input
    }
  };

  const handleEdit = (index, product) => {
    setEditRowIndex(index);
    setEditValues(product);
  };

  const handleEditChange = (key, value) => {
    setEditValues({ ...editValues, [key]: value });
  };

  const handleSaveEdit = async (productId) => {
    const requiredFields = [
      "Shape",
      "Certificate No",
      "Carat",
      "Color",
      "Clarity",
      "Cut",
      "Polish",
      "Symmetry",
      "Fluorescence",
      "Length",
      "Breadth",
      "Height",
      "LAB",
      "Price/ct",
      "Amount",
    ];

    const optionalFields = ["BGM", "H&C", "3EX"]; // These can be empty

    for (const field of requiredFields) {
      if (!editValues[field] || (["Carat", "Length", "Breadth", "Height", "Price/ct", "Amount"].includes(field) && isNaN(editValues[field]))) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: `Please provide a valid value for ${field}.`,
        });
        return;
      }
    }

    // Allow empty values for optional fields
    for (const field of optionalFields) {
      if (editValues[field] === undefined) {
        editValues[field] = "";
      }
    }

    try {
      const originalProduct = products.find((p) => p._id === productId);

      // Check if any field (except uploadedAt) has been changed
      let isChanged = false;
      for (const key of [...requiredFields, ...optionalFields]) {
        if (editValues[key] !== originalProduct[key]) {
          isChanged = true;
          break;
        }
      }
  
      // If no changes are made, do not update the uploadedAt field
      if (!isChanged) {
        Swal.fire("No Changes", "No changes were made to the product.", "info");
        setEditRowIndex(null); // Exit edit mode
        return;
      }
  
      // If changes are made, update the uploadedAt field
      editValues.uploadedAt = new Date();
      // const adminId = localStorage.getItem("adminId");
      const response = await axios.put(`${getBackendUrl()}/api/product/edit-product/${productId}`, {
        product: editValues,
      });

      Swal.fire("Success", response.data.message, "success");

      setEditRowIndex(null);
      fetchProducts();
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.response?.data?.message || "Failed to update product.",
      });
    }
  };

  const handleDeleteUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    setFile2(uploadedFile);

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      if (parsedData.length === 0) {
        Swal.fire("Error", "No data exists inside the file!", "error");
        return;
      }

      setData(parsedData); // Set table data
    };
    reader.readAsBinaryString(uploadedFile);
  };

  const handleDeleteExcel = async () => {
    if (!data || data.length === 0) {
      Swal.fire("Error", "No data exists inside the file!", "error");
      return;
    }

    const certificateNumbers = data.map((row) => row["Certificate No"]).filter(Boolean);

    if (certificateNumbers.length === 0) {
      Swal.fire("Error", "No valid Certificate No found!", "error");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Please check the data before deleting!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(`${getBackendUrl()}/api/product/delete-products-excel`, {
            certificateNumbers,
          });

          if (response.data.deletedCount === 0) {
            Swal.fire("Error", "Data is not present!", "error");
            return;
          }

          Swal.fire("Deleted!", `${response.data.deletedCount} products deleted successfully!`, "success");

          setFile2(null);
          setData([]);
          fetchProducts();
          fetchSoldProducts();
        } catch (error) {
          console.error("Error deleting products:", error);

          if (error.response && error.response.data.message === "Data is not present") {
            Swal.fire("Error", "Data is not present!", "error");
          } else {
            Swal.fire("Error", "Failed to delete products.", "error");
          }
        }
      }
    });
  };

  const handleSubmit = () => {
    const dataToUpload = uploadedData.map((row) => ({
      Shape: row["Shape"] || "",
      "Certificate No": row["Certificate No"] || "",
      Carat: row["Carat"] || 0,
      Color: row["Color"] || "",
      Clarity: row["Clarity"] || "",
      Cut: row["Cut"] || "",
      Polish: row["Polish"] || "",
      Symmetry: row["Symmetry"] || "",
      "3EX": row["3EX"] || "", // Can be empty
      "H&C": row["H&C"] || "", // Can be empty
      Fluorescence: row["Fluorescence"] || "",
      Length: row["Length"] || 0,
      Breadth: row["Breadth"] || 0,
      Height: row["Height"] || 0,
      LAB: row["LAB"] || "",
      BGM: row["BGM"] || "", // Can be empty
      "Price/ct": row["Price/ct"] || 0,
      Amount: row["Amount"] || 0,
    }));

    // Validate data
    const requiredFields = [
      "Shape",
      "Certificate No",
      "Carat",
      "Color",
      "Clarity",
      "Cut",
      "Polish",
      "Symmetry",
      "Fluorescence",
      "Length",
      "Breadth",
      "Height",
      "LAB",
      "Price/ct",
      "Amount"
    ];

    for (const product of dataToUpload) {
      for (const field of requiredFields) {
        if (!product[field] && product[field] !== 0) {
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: `The field ${field} cannot be empty.`,
          });
          return;
        }
      }
    }

    // const adminId = localStorage.getItem("adminId");
    const payload = { products: dataToUpload };
    console.log("file", file);

    axios.post(`${getBackendUrl()}/api/product/add-product`, payload)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Data Uploaded",
          text: response.data.message,
        });
        fetchProducts();
        fetchSoldProducts();
        setUploadedData([]);
        setIsSubmitted(true);
        setFile(null);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: "There was an error while uploading the data.",
        });
        console.error(error);
      });
  };


  const handleNewUpload = () => {
    setIsSubmitted(false); // Show the upload section again
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input value
    }
  };


  useEffect(() => {
    // if (isLoggedIn) {
      fetchProducts();
      fetchSoldProducts(certificateSearchTerm);
    // }
  }, [fetchProducts, fetchSoldProducts, certificateSearchTerm, soldCurrentPage, soldItemsPerPage]);

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     fetchProducts();
  //     fetchSoldProducts();
  //   }
  // }, [isLoggedIn, fetchProducts, fetchSoldProducts]);

  useEffect(() => {
    if (showProducts) {
      fetchProducts();
    }
  }, [fetchProducts, showProducts, currentPage, itemsPerPage]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };
  
  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = Number(e.target.value);
    if (newItemsPerPage !== itemsPerPage) {
      setItemsPerPage(newItemsPerPage);
      setCurrentPage(1); // Reset to first page when changing items per page
    }
  };

  const handlePageChange1 = ({ selected }) => {
    setSoldCurrentPage(selected + 1); // selected starts from 0, so add 1
  };

  const handleItemsPerPageChange1 = (e) => {
    setSoldItemsPerPage(Number(e.target.value));
    setSoldCurrentPage(1); // Reset to first page
  };

  // if (!isLoggedIn) {
  //   return (
  //     <div className="auth-container">
  //       {isSignup ? (
  //         <div className="form-container">
  //           <h2>Signup</h2>
  //           <input
  //             type="text"
  //             placeholder="Name"
  //             value={name}
  //             onChange={(e) => setName(e.target.value)}
  //           />
  //           <input
  //             type="email"
  //             placeholder="Email"
  //             value={email}
  //             onChange={(e) => setEmail(e.target.value)}
  //           />
  //           <input
  //             type="password"
  //             placeholder="Password"
  //             value={password}
  //             onChange={(e) => setPassword(e.target.value)}
  //           />
  //           <button className='signup-button' onClick={handleSignup}>Signup</button>
  //           <p>
  //             Already have an account? <span onClick={() => setIsSignup(false)}>Login here</span>
  //           </p>
  //         </div>
  //       ) : (
  //         <div className="form-container">
  //           <h2>Login</h2>
  //           <input
  //             type="email"
  //             placeholder="Email"
  //             value={email}
  //             onChange={(e) => setEmail(e.target.value)}
  //           />
  //           <input
  //             type="password"
  //             placeholder="Password"
  //             value={password}
  //             onChange={(e) => setPassword(e.target.value)}
  //           />
  //           <button className='signup-button' onClick={handleLogin}>Login</button>
  //           {/* <p>
  //             Don't have an account? <span onClick={() => setIsSignup(true)}>Signup here</span>
  //           </p> */}
  //         </div>
  //       )}
  //     </div>
  //   );
  // }

  const downloadExcel = () => {
    if (products.length === 0) return;

    // Remove "Sr No" column before exporting
    const formattedData = products.map(({ _id, adminId, __v, ...rest }) => rest);

    const ws = XLSX.utils.json_to_sheet(formattedData); // Convert to worksheet
    const wb = XLSX.utils.book_new(); // Create new workbook
    XLSX.utils.book_append_sheet(wb, ws, "Fetched Products"); // Append sheet
    XLSX.writeFile(wb, "Fetched_Products.xlsx"); // Download as Excel file
  };

  const downloadSoldStockExcel = () => {
    if (soldProducts.length === 0) return;

    // Remove "Sr No", "_id", "adminId", "__v", and "isSold" columns before exporting
    const formattedData = soldProducts.map(({ _id, adminId, __v, isSold, ...rest }) => rest);

    const ws = XLSX.utils.json_to_sheet(formattedData); // Convert to worksheet
    const wb = XLSX.utils.book_new(); // Create new workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sold Stock"); // Append sheet
    XLSX.writeFile(wb, "Sold_Stock.xlsx"); // Download as Excel file
  };

  return (
    <div className="admin-container">
      <h1>Tanaya Jewel Admin Dashboard</h1>
      <div className="upload-section">
        {!isSubmitted ? (
          <>
            <h2>Upload Excel</h2>
            <input
              type="file"
              accept=".xlsx, .xls"
              ref={fileInputRef}
              onChange={handleFileUpload}
            />

            {/* Uploaded Products Table */}
            {!isSubmitted && uploadedData.length > 0 && (
              <div className="product-tables">
                <h2>Uploaded Products</h2>
                <div className="uploaded-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Sr No</th> {/* New Serial Number Column */}
                        {Object.keys(uploadedData[0] || {}).map((key, index) => (
                          <th key={index}>{key}</th> // Headers in original order
                        ))}

                      </tr>
                    </thead>
                    <tbody>
                      {uploadedData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td>{rowIndex + 1}</td>
                          {/* {Object.keys(row).map((key, valueIndex) => ( // Ensure correct order
                            <td key={valueIndex}>{row[key]}</td>
                          ))} */}
                          {Object.entries(row).map(([key, value], valueIndex) => {
                            let formattedValue = value;
                            // Check if the current key is "Price/ct" or "Amount"
                            // and format it to 4 decimals if it's not an integer.
                            if ((key === "Price/ct" || key === "Amount") && !Number.isInteger(Number(value))) {
                              formattedValue = parseFloat(value).toFixed(4);
                            }
                            return <td key={valueIndex}>{formattedValue}</td>;
                          })}

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            {/* Buttons */}
            {uploadedData.length > 0 && (
              <div className="buttons-section">
                <button
                  className="remove-file-button"
                  onClick={handleRemoveFile}
                >
                  Remove File
                </button>
                <button
                  className="submit-button"
                  onClick={handleSubmit}
                >
                  Submit Data
                </button>
              </div>
            )}

          </>
        ) : (
          <div className="new-upload-section">
            <button
              onClick={handleNewUpload}
              className="new-upload-button"
            >
              Upload New File
            </button>
          </div>
        )}
      </div>
      <div className="product-tables">
        {/* Fetched Products Table */}
        {!showProducts && (
          <button
            className="show-products-btn"
            onClick={() => setShowProducts(true)}
            style={{ backgroundColor: "#000000", color: "#fff", padding: "10px 20px", border: "none", cursor: "pointer", borderRadius: "5px" }}
          >
            Show Products
          </button>
        )}

        {showProducts && (
          products.length > 0 ? (
            <div>
              <h2>Fetched Products</h2>
              <div className="admin-container-show">
                <div className="items-per-page">
                  <label>Show:</label>
                  <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                    <option value="20">20</option>
                    <option value="40">40</option>
                    <option value="60">60</option>
                    <option value="80">80</option>
                    <option value="100">100</option>
                  </select>
                  <div className="delete-items">
                    <button onClick={deleteSelectedProducts} disabled={selectedProducts.size === 0}>
                      Delete Selected Products
                    </button>

                    <button onClick={() => document.getElementById("fileInput").click()}>
                      Upload Excel
                    </button>
                    <input id="fileInput" ref={fileInputRef2} type="file" accept=".xlsx, .xls" style={{ display: "none" }} onChange={handleDeleteUpload} />
                  </div>
                </div>

                {file2 && (
                  <div className="uploaded-data">
                    <p>Uploaded File: {file2.name}</p>

                    <div className="table-container">
                      <table>
                        <thead>
                          <tr>
                            <th>Sr No</th> {/* Serial Number Column */}
                            {data.length > 0
                              ? Object.keys(data[0]).map((key, index) => <th key={index}>{key}</th>)
                              : <th>No Data Available</th>}
                          </tr>
                        </thead>

                        <tbody>
                          {data.length > 0 ? (
                            data.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                <td>{rowIndex + 1}</td> {/* Serial Number */}
                                {Object.keys(data[0]).map((key, colIndex) => (
                                  // Ensures original column order
                                  <td key={colIndex}>{row[key] !== undefined && row[key] !== null ? row[key] : ""}</td>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="100%">No Data Available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                    </div>
                    <div className='delete-data'>
                      <button className="delete-products" onClick={handleDeleteExcel}>
                        Delete Products
                      </button>
                      <button
                        className="delete-products"
                        onClick={handleRemoveFile2}
                      >
                        Remove File
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="fetched-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      {Object.keys(products[0] || {})
                        .filter((key) => key !== "_id" && key !== "adminId" && key !== "__v" && key !== "isSold" && key !== "uploadedAt")
                        .map((key, index) => (
                          <th key={index}>{key}</th>
                        ))}
                        <th>Last Updated At</th> 
                      <th>Actions</th> {/* Add actions column */}
                    </tr>
                  </thead>
                  <tbody>
  {products.map((row, rowIndex) => (
    <tr
      key={row._id}
      onClick={() => toggleSelection(row._id)}
      style={{ backgroundColor: selectedProducts.has(row._id) ? 'rgb(165 169 165 / 23%)' : 'transparent', cursor: 'pointer' }}
    >
      <td>{rowIndex + 1}</td>
      {Object.entries(row)
        .filter(([key]) => key !== "_id" && key !== "adminId" && key !== "__v" && key !== "isSold" && key !== "uploadedAt")
        .map(([key, value], valueIndex) => {
          if (rowIndex === editRowIndex) {
            return (
              <td key={valueIndex}>
                <input
                  type={["Carat", "Length", "Breadth", "Height", "Price/ct", "Amount"].includes(key) ? "number" : "text"}
                  value={editValues[key]}
                  onChange={(e) => handleEditChange(key, e.target.value)}
                />
              </td>
            );
          }
          let formattedValue = value;
          if ((key === "Price/ct" || key === "Amount") && !Number.isInteger(Number(value))) {
            formattedValue = parseFloat(value).toFixed(4);
          }
          return <td key={valueIndex}>{formattedValue}</td>;
        })}
      <td>
        {new Date(row.uploadedAt).toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        })}
      </td>
      <td>
        {rowIndex === editRowIndex ? (
          <>
            <button className="action-button" onClick={() => handleSaveEdit(row._id)}>Save</button>
            <button className="cancel-button" onClick={() => setEditRowIndex(null)}>Cancel</button>
          </>
        ) : (
          <div>
            <FaEdit className="icon edit-icon" onClick={() => handleEdit(rowIndex, row)} />
          </div>
        )}
      </td>
    </tr>
  ))}
</tbody>

                </table>
              </div>
              {totalPages > 1 && (
  <div className="pagination-container">
    <ReactPaginate
      previousLabel={"Prev"}
      nextLabel={"Next"}
      breakLabel={"..."}
      pageCount={totalPages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={3}
      onPageChange={handlePageChange}
      containerClassName={"pagination"}
      activeClassName={"active"}
      forcePage={currentPage - 1} // Add this to sync with currentPage
      disableInitialCallback={true} // Prevent initial callback
    />
  </div>
)}
              <div className="download-excel-btn-container">
                <button className="download-excel-btn" onClick={downloadExcel}>
                  Download Excel
                </button>
                <button
                  className="hide-products-btn"
                  onClick={() => setShowProducts(false)}
                  style={{ marginLeft: "10px", backgroundColor: "#000000", color: "#fff", padding: "10px 20px", border: "none", cursor: "pointer", borderRadius: "5px", fontSize: "16px" }}
                >
                  Hide
                </button>
              </div>
            </div>
          ) : (
            <div className="no-products">
              <p>No products available.</p>
              <button
                className="hide-products-btn"
                onClick={() => setShowProducts(false)}
                style={{ backgroundColor: "#000000", color: "#fff", padding: "10px 20px", border: "none", cursor: "pointer", borderRadius: "5px", fontSize: "16px" }}
              >
                Hide
              </button>
            </div>

          )
        )}
      </div>
      <div className='stock-tables'>
  {!showSoldStock ? (
    <button
      className="show-products-btn"
      onClick={() => setShowSoldStock(true)}
      style={{ backgroundColor: "#000000", color: "#fff", padding: "10px 20px", border: "none", cursor: "pointer", borderRadius: "5px", marginTop: "10px" }}
    >
      Show Sold Stock
    </button>
  ) : (
    <div>
      <h2>Sold Stock</h2>
      <div className="items-per-page">
        <label>Show:</label>
        <select value={soldItemsPerPage} onChange={handleItemsPerPageChange1}>
          <option value="20">20</option>
          <option value="40">40</option>
          <option value="60">60</option>
          <option value="80">80</option>
          <option value="100">100</option>
        </select>
        <input
          type="text"
          placeholder="Search by Certificate No"
          value={certificateSearchTerm}
          onChange={(e) => setCertificateSearchTerm(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        />
      </div>

      {isSearchEmpty ? (
        <p>No matching sold stock found.</p>
      ) : (
        <div className="fetched-table">
          <table>
            <thead>
              <tr>
                <th>Sr No</th>
                {Object.keys(soldProducts[0] || {})
                  .filter(key => key !== "_id" && key !== "adminId" && key !== "__v" && key !== "isSold" && key !== "soldAt")
                  .map((key, index) => <th key={index}>{key}</th>)}
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {soldProducts.map((row, rowIndex) => (
                <tr key={row._id}>
                  <td>{rowIndex + 1}</td>
                  {Object.entries(row)
                    .filter(([key]) => key !== "_id" && key !== "adminId" && key !== "__v" && key !== "isSold" && key !== "soldAt")
                    .map(([key, value], valueIndex) => {
                      let formattedValue = value;
                      if ((key === "Price/ct" || key === "Amount") && !Number.isInteger(Number(value))) {
                        formattedValue = parseFloat(value).toFixed(4);
                      }
                      return <td key={valueIndex}>{formattedValue}</td>;
                    })}
                  <td>
                    {new Date(row.soldAt).toLocaleString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      hour12: false
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="pagination-container">
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          pageCount={soldTotalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange1}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
      <div className="download-excel-btn-container">
        <button className="download-excel-btn" onClick={downloadSoldStockExcel}>
          Download Sold Stock
        </button>
        <button
          className="hide-btn" onClick={() => setShowSoldStock(false)}
          style={{ marginLeft: "10px", backgroundColor: "#000000", color: "#fff", padding: "10px 20px", border: "none", cursor: "pointer", borderRadius: "5px", fontSize: "16px" }}
        >
          Hide
        </button>
      </div>
    </div>
  )}
</div>
    </div>
  );
};

export default AdminPage;
